class VariantDropdown extends HTMLElement {
  constructor() {
    super(); // Call parent constructor
    this.button = null;
    this.optionsContainer = null;
    this.radios = null;
  }

  connectedCallback() {
    // Set up references to the DOM elements within the custom component
    this.button = this.querySelector(".variant-selects_button");
    this.optionsContainer = this.querySelector(
      ".variant-selects_radio-options"
    );
    this.radios = this.optionsContainer.querySelectorAll(".variant_radio");

    // Attach event listeners
    this.setupListeners();
  }

  setupListeners() {
    // Toggle dropdown visibility
    this.button.addEventListener("click", () => this.toggleDropdown());

    // Handle selection
    this.radios.forEach((radio) => {
      radio.addEventListener("change", (event) => this.updateSelection(event));
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (event) => {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    const isHidden = this.optionsContainer.classList.contains("hidden");
    // Close other dropdowns
    document
      .querySelectorAll("variant-dropdown .variant-selects_radio-options")
      .forEach((el) => el.classList.add("hidden"));
    this.optionsContainer.classList.toggle("hidden", !isHidden);
  }

  closeDropdown() {
    this.optionsContainer.classList.add("hidden");
  }

  updateSelection(event) {
    // Update the button text with the selected value
    const selectedValue = event.target.value;
    this.button.querySelector("span").textContent = selectedValue;

    // Close dropdown
    this.closeDropdown();

    // Trigger a custom event (if needed for other scripts to react)
    this.dispatchEvent(
      new CustomEvent("variantSelected", { detail: { value: selectedValue } })
    );
  }
}

// Define the custom element
customElements.define("variant-dropdown", VariantDropdown);

let thumbnailsSwiper = document.querySelector("[swiper='thumbnails']");

if (thumbnailsSwiper) {
  const swiperElement = thumbnailsSwiper.querySelector(".swiper");

  var thumbsSwiper = new Swiper(swiperElement, {
    speed: 300,
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: false,
    centeredSlides: false,
    mousewheel: { forceToAxis: true },

    breakpoints: {
      480: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1 },
      768: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1 },
      992: {
        slidesPerView: "auto",
        spaceBetween: 12,
        slidesPerGroup: 1,
      },
    },
  });
}

let mediaSwiper = document.querySelector("[swiper='media']");

if (mediaSwiper) {
  const swiperElement = mediaSwiper.querySelector(".swiper");

  var swiper = new Swiper(swiperElement, {
    speed: 200,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: false,
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    thumbs: {
      swiper: thumbsSwiper, // Linking the thumbnail slider
    },
    breakpoints: {
      480: { slidesPerView: "auto", spaceBetween: 0, slidesPerGroup: 1 },
      768: { slidesPerView: "auto", spaceBetween: 0, slidesPerGroup: 1 },
      992: {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
    },
  });
}

class SwatchPill extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
  }

  connectedCallback() {
    this.swiper = this.getSwiperInstance();
    this.setupListeners();
  }

  getSwiperInstance() {
    const mediaSwiperElement = document.querySelector(
      "[swiper='media'] .swiper"
    );
    return mediaSwiperElement && mediaSwiperElement.swiper;
  }

  setupListeners() {
    this.addEventListener("change", (event) => this.onVariantChange(event));
  }

  onVariantChange(event) {
    if (!this.swiper) return;

    const selectedImage =
      this.querySelector("[data-image]").getAttribute("data-image");
    if (!selectedImage) return;

    // Find the matching slide with the corresponding data-media attribute
    const mediaSlides = document.querySelectorAll(
      "[swiper='media'] .swiper-slide"
    );
    let targetIndex = -1;

    mediaSlides.forEach((slide, index) => {
      if (slide.getAttribute("data-media") === selectedImage) {
        targetIndex = index;
      }
    });

    if (targetIndex !== -1) {
      this.swiper.slideTo(targetIndex);
    }
  }
}

// Define the custom element
customElements.define("swatch-pill", SwatchPill);

class QualityModalButton extends HTMLElement {
  constructor() {
    super();

    this.qualityModal = document.querySelector('[data-modal="quality"]');
    this.qualityBackground = document.querySelector(".quality_background");
    this.closeElements = document.querySelectorAll(".quality_close");
    this.qualityOpenButtons = document.querySelectorAll(
      '[data-open-modal="quality"]'
    );
    this.openQualityModal = this.openQualityModal.bind(this);
    this.closeQualityModal = this.closeQualityModal.bind(this);
  }

  connectedCallback() {
    this.qualityOpenButtons.forEach((button) => {
      button.addEventListener("click", this.openQualityModal);
    });

    this.closeElements.forEach((element) => {
      element.addEventListener("click", this.closeQualityModal);
    });

    this.qualityBackground.addEventListener("click", this.closeQualityModal);
  }

  openQualityModal() {
    this.qualityModal.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }

  closeQualityModal() {
    this.qualityModal.classList.add("hidden");
    document.body.style.overflow = "";
  }
}




// Define the custom element
customElements.define("quality-modal-button", QualityModalButton);

const openModalButton = document.getElementById('open-lightbox');
const modal = document.getElementById('lightbox');
const closeModalButton = document.getElementById('close-lightbox');

function openModal() {
  modal.classList.remove("hidden")
  modal.setAttribute('aria-hidden', 'false');
  openModalButton.setAttribute('aria-expanded', 'true');
  closeModalButton.focus();

  const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  });
}

function closeModal() {
  modal.classList.add("hidden")
  modal.setAttribute('aria-hidden', 'true');
  openModalButton.setAttribute('aria-expanded', 'false');
  openModalButton.focus();
}

openModalButton.addEventListener('click', openModal);
closeModalButton.addEventListener('click', closeModal);

window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && !modal.hidden) {
    closeModal();
  }
});

let lightboxSwiper = document.querySelector("[swiper='lightbox']");

if (lightboxSwiper) {
  const swiperElement = lightboxSwiper.querySelector(".swiper");

  const prevButton = lightboxSwiper.querySelector("[swiper='prev']");
  const nextButton = lightboxSwiper.querySelector("[swiper='next']");

  var swiper = new Swiper(swiperElement, {
    speed: 0,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      disabledClass: "hide",
    },
    breakpoints: {
      480: { slidesPerView: "auto", spaceBetween: 0, slidesPerGroup: 1 },
      768: { slidesPerView: "auto", spaceBetween: 0, slidesPerGroup: 1 },
      992: {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
    },
  });
}
